import loadable from "@loadable/component";
import CTA from "../components/cta/Cta";
import MicroBanner from "../components/microBanner/MicroBanner";
import format from "@v4/utils/formatContentfulRichText";
const MarketoForm = loadable(() => import("../components/marketoForm/MarketoForm"));
const MicroFormattedCode = loadable(() => import("../components/microFormattedCode/MicroFormattedCode"));

const formatContentfulRichText = () => format(MarketoForm, MicroBanner, MicroFormattedCode, CTA);

export default formatContentfulRichText;
